export const NOTIFICATION_LANGUAGES = [
  { label: 'Русский', code: 'ru' },
  { label: 'English', code: 'en' },
  { label: 'Türkçe', code: 'tr' },
  { label: 'Türkmençe', code: 'tk' },
];

export const NOTIFICATION_STATUSES = [
  { label: 'Новый', key: 'new' },
  { label: 'В обработке', key: 'processing' },
  { label: 'Готово', key: 'completed' },
  { label: 'Уточнения', key: 'clarification' },
  { label: 'Ожидание', key: 'pending' },
  { label: 'Отменено', key: 'cancelled' },
  { label: 'Ошибка', key: 'failed' },
  { label: 'Возврат', key: 'refund' },
  { label: 'Покупка билета', key: 'ticket_purchase' },
  { label: 'Начисление награды', key: 'reward' },
];

export const REWARD_PLACEHOLDERS =
  '[reward_type], [reward_amount], [currency], [reward_percent], [reward_percent_line], [balance_after], [order_id], [customer_name]';
